import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticleSection() {
  return (
    <section id="articles" className="bg-background-100 py-20 md:py-28">
      <div className="w-full px-6 md:px-10 max-w-6xl mx-auto">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between mb-10 gap-3">
          <div>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-2">
              Latest Sourcing Guides
            </h2>
            <p className="text-foreground-600 text-sm">
              {articles.length} SEO articles to boost your dropshipping business
            </p>
          </div>
          <Link
            to="/guide/what-is-allchinabuy-spreadsheet"
            className="text-primary-600 hover:text-primary-700 text-sm font-medium whitespace-nowrap flex items-center gap-1 transition-colors duration-300"
          >
            View All Articles
            <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        {/* Article Cards - show all */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {articles.map((article) => (
            <Link
              key={article.slug}
              to={`/guide/${article.slug}`}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-accent-200/60 transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-3 right-3">
                  <span className="px-2.5 py-1 bg-background-50/90 backdrop-blur-sm text-foreground-700 text-xs font-medium rounded-full">
                    {article.date.split(' ')[2]}
                  </span>
                </div>
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 bg-accent-500/90 text-white text-xs font-medium rounded-full">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h4 className="font-heading text-base font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors duration-300 line-clamp-2">
                  {article.title}
                </h4>
                <p className="text-foreground-500 text-xs leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <p className="text-foreground-400 text-xs mt-3">{article.date}</p>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/guide/what-is-allchinabuy-spreadsheet"
            className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-white rounded-lg text-sm font-semibold hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Read the Complete Guide
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}